<main id="main" class="error-403">
  <header class="ba-content-header ba-with-overlay ba-with-image">
    <div class="ba-header-image"><img class="img403" src="errors/error403.svg" alt=""></div>
    <div class="ba-content-wrap">
      <div class="ba-overlay">
        <h1>{{ "error.http.403.title" | i18next }}</h1>
      </div>
    </div>
  </header>
  <div class="container-fluid ba-copytext">
    <p>{{ "error.http.403.description" | i18next }}</p>
  </div>
  <div class="container-fluid ba-copytext">
    <h2>{{ "error.http.403.causes.title" | i18next }}</h2>
    <ul>
      <li>{{ "error.http.403-betriebe.causes.cause-only-ubvo" | i18next }}</li>
      <li>
        {{ "error.http.403-betriebe.causes.cause-roles" | i18next }} <a href="https://www.arbeitsagentur.de/link/ubvo " target="_blank">{{ "error.http.403-betriebe.causes.cause-roles-link" | i18next }}</a>.
    </li>
    </ul>
    <a [href]="profilUrl" class="ba-btn ba-btn-primary">{{ "error.http.403-betriebe.actions.profile" | i18next }}</a>
  </div>
</main>